export const frontHost = process.env.NODE_ENV === "development" ? 'http://localhost:5100' : 'https://exciteenterprise.com'
